export const actionTypes = {
  showPanel: 'showPanel',
  hidePanel: 'hidePanel',
  togglePanel: 'togglePanel',
}

export const actions = {
  showPanel: id => ({
    type: actionTypes.showPanel,
    payload: { id },
  }),
  hidePanel: id => ({
    type: actionTypes.hidePanel,
    payload: { id },
  }),
  togglePanel: id => ({
    type: actionTypes.togglePanel,
    payload: { id },
  }),
}
